import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable()
export class OnScreenMessageService {
    constructor(private messageService: MessageService) {}

    Success(message?: string) {
        this.messageService.add({severity:'success', summary:'Sucesss Message', detail: message});
    }

    Warning(message?: string) {
        this.messageService.add({severity:'warn', summary:'Warning Message', detail: message});
    }

    Error(message?: string) {
        this.messageService.add({severity:'error', summary:'Error Message', detail: message});
    }

    Info(message?: string) {
        this.messageService.add({severity:'info', summary:'Info Message', detail: message});
    }
}